var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #413fbb;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-1",
    d: "M1583,256a12,12,0,1,0,12,12,12,12,0,0,0-12-12h0Zm5.76,9.923-1.03,5.158a2.567,2.567,0,0,1-2.51,2.062h-7.18a0.858,0.858,0,0,1,0-1.715h7.18a0.852,0.852,0,0,0,.83-0.683l1.03-5.158a0.852,0.852,0,0,0-.67-1,0.791,0.791,0,0,0-.16-0.017h-6.49a0.857,0.857,0,1,1,0-1.714h6.49a2.566,2.566,0,0,1,2.56,2.565,2.808,2.808,0,0,1-.05.5h0Zm-10.72,1.22h3.43a0.857,0.857,0,1,1,0,1.714h-3.43A0.857,0.857,0,0,1,1578.04,267.143Z",
    transform: "translate(-1571 -256)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.60759632e9ffa177be0e06cd4d241108.svg";
export { ForwardRef as ReactComponent };